import React, { useState } from "react";
import {
  NotificationOutlined,
  HomeOutlined,
  MobileOutlined,
  SettingOutlined,
  ShoppingOutlined,
  PayCircleOutlined,
} from "@ant-design/icons";
import { Breadcrumb, Layout, Menu, theme } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import pokeFondo from "../Assets/pokeball.png";
import { Navbar } from "../common/Colores";


const { Header, Content, Footer, Sider } = Layout;

const UserLayout = () => {
  const location = useLocation();
  const isDesktopOrLaptop =  useMediaQuery({ query: '(min-device-width: 1224px)' });
  const rutas = [
    "/home",
    "/gashaponv2",
    "/objetos",
    "/pokedex",
    "/novedades",
    "/configuracion",
  ];
 
  let navigate = useNavigate();

  const itemsMovil = [
    {
      key: "0",
      icon: <HomeOutlined style={{color:rutas.indexOf(location.pathname).toString() == "0" ? Navbar.btnActivo : Navbar.btns, margin: "0 10px"}}/>,
      onClick: () => {
        navigate("/home");
      },
    },
    {
      key: "1",
      icon: <PayCircleOutlined style={{color:rutas.indexOf(location.pathname).toString() == "1" ? Navbar.btnActivo : Navbar.btns, margin: "0 10px"}}/>,
      onClick: () => {
        navigate("/gashaponv2");
      },
    },
    {
      key: "2",
      icon: <ShoppingOutlined style={{color:rutas.indexOf(location.pathname).toString() == "2" ? Navbar.btnActivo : Navbar.btns, margin: "0 10px"}}/>,
      onClick: () => navigate("/objetos"),
    },
    { key: "3", icon: <MobileOutlined style={{color:rutas.indexOf(location.pathname).toString() == "3" ? Navbar.btnActivo : Navbar.btns, margin: "0 10px"}}/>, onClick: () => {navigate("/pokedex")} },
    {
      key: "4",
      icon: <SettingOutlined style={{color:rutas.indexOf(location.pathname).toString() == "4" ? Navbar.btnActivo : Navbar.btns, margin: "0 10px"}}/>,
      onClick: () => navigate("/configuracion"),
    },
  ];

  const itemDesktop = [
    {
      label: "Inicio",
      key: "0",
      icon: <HomeOutlined/>,
      onClick: () => navigate("/home"),
    },
    {
      label: "Objetos",
      key: "1",
      icon: <ShoppingOutlined />,
      onClick: () => navigate("/objetos"),
    },
    {
      label: "Pokedex",
      key: "2",
      icon: <MobileOutlined />,
      onClick: () => navigate("/pokedex"),
    },
    {
      label: "Configuracion",
      key: "3",
      icon: <SettingOutlined />,
      onClick: () => navigate("/configuracion"),
    },
  ];

  const [collapsed, setCollapsed] = useState(false);

  

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {isDesktopOrLaptop && (
        <Sider
          style={{
            zIndex: 10,
          }}
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
        >
          <div
            style={{
              backgroundColor: "#334454",
              marginTop: "20%",
              margin: "1rem",
              padding: "0.5rem",
              alignItems:"center",
              borderRadius:"0.5rem"
            }}
          >
            <h3 style={{ color: "#FFFF", textAlign:"center" }}>WONDER PIECE</h3>
          </div>
          <Menu
            theme="dark"
            defaultSelectedKeys={[rutas.indexOf(location.pathname).toString()]}
            mode="inline"
            items={itemDesktop}
          />
        </Sider>
      )}
      <Content
        style={
          isDesktopOrLaptop
            ? { margin: "24px 16px 0", overflow: "initial" }
            : {}
        }
      >
        <div
          style={{
            height: "100%",
            width: "100%",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `url(${pokeFondo})`,
              backgroundPosition: "center",
              backgroundRepeat: "center",
              filter: "invert(100%) opacity(40%) blur(2px)",
              zIndex: 0,
            }}
          />
          {/* <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.1)", 
              zIndex: 1,
            }}
          /> */}

        
          <div style={{ position: "relative" }}>
            <Outlet />
          </div>
        </div>
      </Content>
      {!isDesktopOrLaptop && (
        <Header
          style={{
            position: "absolute",
            bottom: 0,
            zIndex: 10,
            width: "100%",
            display: "flex",
            alignItems: "center",
            backgroundColor:Navbar.background,
          }}
        >
          
          <Menu
            theme="dark"
            mode="horizontal"
            defaultSelectedKeys={[rutas.indexOf(location.pathname).toString()]}
            items={itemsMovil}
            style={{
              backgroundColor:Navbar.background,
              flex: 1,
              justifyContent: "center",
              display: "flex",
            }}
          />
        </Header>
      )}
    </Layout>
  );
};

export default UserLayout;

